<template>
  <section class="bg-white shadow-lg p-4 sm:p-8 w-full sm:w-auto min-w-0 sm:min-w-[55rem]">
    <div v-if="!isRenderLoading" class="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
      <!-- DYNAMIC COLUMNS -->
      <div class="flex justify-between items-center pb-5">
        <div class="flex gap-4 items-center">
          <img
            class="w-14 h-14 object-cover rounded-full"
            :src="$store.state.userAvatar"
            alt="Profile"
          />
          <div class="leading-8 flex flex-col">
            <span class="text-primarydark text-lg">{{ $store.state.userLogged }}</span>
            <span class="text-zinc-400 text-sm font-normal"></span>
            <div @click="logoutHandler()">Logout</div>
          </div>
        </div>
        <div @click="$emit('toggle-sidebar')">
          <ChevronSVG />
        </div>
      </div>
      <div v-for="module in itemMenuCategory" :key="module.id" class="space-y-3">
        <!-- MODULE NAME -->
        <h2 class="text-orange-600 font-semibold uppercase tracking-wide text-sm sm:text-sm">
          {{ module.name }}
        </h2>

        <!-- MODULE SECTIONS -->
        <ul class="mt-2 space-y-2 sm:space-y-3 text-gray-700 text-sm sm:text-sm">
          <li
            v-for="section in module.moduleSections"
            :key="section.id"
            class="flex items-center gap-2"
          >
            <router-link
              class="flex gap-2 items-center w-full"
              :to="`/portal/${module.code}/${section.code}/${encryptFile(section.id)}`"
              @click="$emit('toggle-sidebar', false)"
            >
              <!-- ICON -->
              <template v-if="section.icon && section.icon.filename">
                <component :is="section.icon.filename" height="16" width="16" />
              </template>

              <!-- SECTION NAME -->
              <span> {{ section.name }} </span>

              <!-- UNREAD BADGE -->
              <span
                v-if="unreadMap[section.id]"
                class="ml-1 px-2 py-0.5 text-[0.55rem] sm:text-xs font-medium text-white bg-red-500 rounded-full"
              >
                {{ unreadMap[section.id] }}
              </span>

              <!-- SOON LABEL -->
              <span v-if="section.page_layout === 'blank'">
                <span
                  class="px-2 py-0.5 text-[0.55rem] sm:text-xs font-medium text-blue-600 bg-blue-100 rounded-md border border-blue-200"
                >
                  Soon
                </span>
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- LOADING -->
    <div v-else class="flex justify-center items-center">
      <LoadingGlobal />
    </div>
  </section>
</template>

<script>
import MegaPhoneIcon from '@/components/svgs/icons/megaphone-icon.vue';
import BellIcon from '@/components/svgs/icons/bell-icon.vue';
import BuildingIcon from '@/components/svgs/icons/building-icon.vue';
import HeartIcon from '@/components/svgs/icons/heart-icon.vue';
import HierarchyIcon from '@/components/svgs/icons/hierarchy-icon.vue';
import CalendarIcon from '@/components/svgs/icons/calendar-icon.vue';
import CalendarCloseIcon from '@/components/svgs/icons/calendar-close-icon.vue';
import PartyIcon from '@/components/svgs/icons/party-icon.vue';
import encryptHandler from '@/utils/encrypt';
import countBadgeHandler from '@/utils/reusables/countBadgeNotif';
import ChevronSVG from '@/components/svgs/ChevronRightSvg.vue';
import { inject, onMounted, ref, computed } from 'vue';

import { useRouter } from 'vue-router';
export default {
  components: {
    ChevronSVG,
    'megaphone-icon': MegaPhoneIcon,
    'bell-icon': BellIcon,
    'building-icon': BuildingIcon,
    'heart-icon': HeartIcon,
    'hierarchy-icon': HierarchyIcon,
    'calendar-icon': CalendarIcon,
    'calendar-close-icon': CalendarCloseIcon,
    'party-icon': PartyIcon
  },
  setup() {
    const router = useRouter();
    const { encryptFile } = encryptHandler();
    const { sectionCountUnreadHandler, sectionCountBadgeUnread } = countBadgeHandler();
    const axios = inject('$axios');

    const isRenderLoading = ref(true);
    const itemMenuCategory = ref([]);

    onMounted(async () => {
      try {
        const { data } = await axios.get('/api/modules', {
          params: { includeSectionPosts: false }
        });

        if (data?.data) {
          itemMenuCategory.value = data.data;
          await sectionCountUnreadHandler();
        }
      } catch (error) {
        console.log('render error:', error.response);
      } finally {
        isRenderLoading.value = false;
      }
    });

    const unreadMap = computed(() => {
      const map = {};
      sectionCountBadgeUnread.value.forEach((item) => {
        map[item.section_id] = item.unreadCount;
      });
      return map;
    });

    const logoutHandler = () => {
      localStorage.removeItem(process.env.VUE_APP_AUTH_TOKEN);
      router.push('/');
    };

    return {
      itemMenuCategory,
      encryptFile,
      isRenderLoading,
      unreadMap,
      logoutHandler
    };
  }
};
</script>
